import React, { useContext, useEffect, useState } from "react";
import { MenuItem, TextField, Button } from "@mui/material";
import { ContextData } from "../../../../context/Context";
import GetAdminCredentials from "../../../../context/GetAdminCredentials";
import { Putrequest } from "../../../../context/AxiosRequest";
import { toast } from "react-toastify";
import SoundAlert from "../../../../routes/SoundAlert"

function UpdatePassword() {
  // Sample data for dropdown menus


  const {UserTokens,accesstoken} = useContext(ContextData)
   const [AdminData,setAdminData] = useState('')

  // State for form inputs
  const [formData, setFormData] = useState({
    email: "",
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });



     useEffect(()=>{
       
                      GetAdminCredentials(UserTokens,accesstoken).then(res =>{
                    
                      setAdminData(res)

                       setFormData(prev =>({...prev, email: res[0].email,user_token:res[0].userToken}))
  
                      })

     },[])




  // Handler for input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handler for file input change
  const handleFileChange = () => {


                 if(formData.newPassword === ""){

                  toast.warn("Password input is empty")
                  SoundAlert("error")
                  return
           }
  
         (async()=>{


            const response = await Putrequest("/auth/admin_update_password",formData,accesstoken)

            if(response.status){

                 toast.success(response.statusText)
                 SoundAlert("success")
                 
            }else{

                toast.warn(response.statusText)
                 SoundAlert("error")
            }







         })()



  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold mb-4">Change Your Password</h2>
      <div className="space-y-4 text-left">
        {/* Department Dropdown */}


        <TextField
          label="Email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
          disabled
        />


        <TextField
          label="Old Password"
          name="oldPassword"
          value={formData.oldPassword}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />


        <TextField
          label="New Password"
          name="newPassword"
          value={formData.newPassword}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        />


       {/*  <TextField
          label="Confirm New Password"
          name="confirmNewPassword"
          value={formData.confirmNewPassword}
          onChange={handleChange}
          fullWidth
          variant="outlined"
          className="bg-white"
        /> */}


        {/* Submit Button */}
        <Button onClick={handleFileChange} type="submit" variant="contained" color="primary" className="w-full">
          Submit
        </Button>

      </div>
    </div>
  );
}

export default UpdatePassword;
